import { css, CSSResult } from 'lit'
import { csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csFontBody } from 'elements/_shared/fonts.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'

export const cseDropdown = {
  colorDisabled: css`var(--cse-dropdown-color-disabled, ${csColorText.muted})`,
}

export const style: CSSResult = css`
  :host([full-width]) {
    display: flex;
    width: 100%;
  }

  :host([full-width]) .anchor {
    flex: 1;
    min-width: 0;
  }

  :host {
    position: relative;
    display: inline-flex;
    align-items: center;
  }

  .anchor:not(.disabled) {
    cursor: pointer;
  }

  .default-anchor {
    display: flex;
    align-items: center;
    user-select: none;
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    color: inherit;
    gap: ${csSpacing.spacing04};
  }

  .description {
    --cse-text-color: ${csFontBody.color};
    --cs-font-body-s-font-weight: 700;
  }

  [icon-role="cse-dropdown.arrow"] {
    transition-duration: ${csTransition.duration};
    transition-property: transform;
    transition-timing-function: ${csTransition.timingFunction};
  }

  .icon-open {
    transform: rotate(180deg);
  }

  .align-right {
    justify-content: flex-end;
  }

  .disabled {
    --cs-font-body-s-color: ${cseDropdown.colorDisabled};
    color: ${cseDropdown.colorDisabled};
  }
`
